export enum NotificationType {
    AGREEMENT = "Agreement",
    ANCILLARY_DOCUMENT = "AncillaryDocument",
    ONBOARDING = "OnboardingItem",
    OTHER_ITEM = "OtherItem"
}